import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';
import type { GetRecentTournamentsPlayerResultsResponse } from '@swf/generated/types/api/v0/SwHomeGames';
import type { GetRecentTournamentsPlayerResultsRequest } from '@swf/generated/types/api/v1-preview/SwHomeGames';
import type { HomeGamesWidgetModel } from '@swf/poker';
import { PKR_LOADERS } from '@swf/poker';

export const fetchPlayerTournamentResults = async (
  { tournId }: GetRecentTournamentsPlayerResultsRequest,
  { request, dispatch, widget: { id } }: WidgetEffectParams<void>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[id];
  const loaderName = PKR_LOADERS.playerTournamentResults;

  widgetDispatch.setLoading({ isLoading: true, loaderName });

  try {
    const {
      body: { success, recentTournResultsReply }
    } = await request<GetRecentTournamentsPlayerResultsResponse>({
      service: 'homeGames.getRecentTournamentsPlayerResultsRequest',
      body: { tournId } as GetRecentTournamentsPlayerResultsRequest
    });

    if (success && recentTournResultsReply?.playerResults) {
      widgetDispatch.setPlayerTournamentResults(recentTournResultsReply?.playerResults);
    }
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
